import { inject, Injectable } from '@angular/core';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CarrierNewsItemDto } from '../models/carrier-news-item-dto';

@Injectable({
  providedIn: 'root',
})
export class CarrierNewsService {
  // Injections
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  // Fields
  private readonly baseUrl = `${this.environment.url.api}Transport/CarrierNews`;

  public getCarrierNews(): Observable<CarrierNewsItemDto[]> {
    return this.httpClient.get<CarrierNewsItemDto[]>(`${this.baseUrl}`, this.getRequestOptions());
  }

  private getRequestOptions() {
    const headers = new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-skip-loading-interceptor-handling': 'true',
    });
    return { headers };
  }
}
